<template>
  <div>
    <b-modal
        id="modal-delete-personalization"
        ref="modal-delete-personalization"
        footer-class="flex-nowrap"
        no-close-on-backdrop
        centered
    >
      <template #modal-header>
        <h3>{{ $t('modals.deletePersonalizationSet.title') }}</h3>
      </template>

      <template #default>
        <div class="delete-icon text-center">
          <b-icon icon="exclamation-triangle-fill" variant="danger" class="mt-5 mb-4"></b-icon>
          <div class="mt-2 mb-4">{{ $t('modals.deletePersonalizationSet.message') }}</div>
        </div>
      </template>

      <template #modal-footer>
        <b-button
            class="p-3 border-right-light-grey"
            block
            @click="cancelModal"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
            variant="primary"
            class="p-3"
            block
            @click="deletePersonalizationSet"
        >
          {{ $t('modals.deletePersonalizationSet.validate') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalDeletePersonalizationSet',
  mounted() {
    this.$refs['modal-delete-personalization'].show();
  },
  methods: {
    deletePersonalizationSet() {
      this.$emit('delete-personalization-set');
      const modalRef = 'modal-delete-personalization';
      this.$refs[modalRef].hide();
    },
    cancelModal() {
      this.$emit('close-delete-personalization-set');
    },
  },
};
</script>

<style scoped lang="scss">
.delete-icon svg {
  font-size: 80px;
}
</style>
